export default class KnownInternalNames {
    static Networks = class {
        public static readonly ArbitrumSepolia: string = "eip155:421614";

        public static readonly ArbitrumMainnet: string = "eip155:42161";

        public static readonly EthereumSepolia: string = "eip155:11155111";

        public static readonly EthereumMainnet: string = "eip155:1";

        public static readonly BaseSepolia: string = "eip155:84532";

        public static readonly BaseMainnet: string = "eip155:8453";

        public static readonly MonadTestnet: string = "eip155:10143";

        public static readonly AztecDevnet: string = "aztec:aztec-devnet"

        public static readonly AztecTestnet: string = "aztec:1821665230"

        public static readonly SolanaDevnet: string = "solana:devnet";

        public static readonly SolanaMainnet: string = "solana:mainnet";

        public static readonly SolanaTestnet: string = "solana:testnet";

        public static readonly TronMainnet: string = "TRON_MAINNET"

        public static readonly TronNile: string = "tron:3448148188"

        public static readonly FuelMainnet: string = "FUEL_MAINNET"

        public static readonly FuelTestnet: string = "FUEL_TESTNET"

        public static readonly FuelDevnet: string = "FUEL_DEVNET"

        public static readonly StarkNetGoerli: string = "STARKNET_GOERLI";

        public static readonly StarkNetMainnet: string = "STARKNET_MAINNET";

        public static readonly StarkNetSepolia: string = "starknet:SN_SEPOLIA";

        public static readonly TONMainnet: string = "ton:mainnet";

    }

}